export const getNewPageNumberOnPageSizeChange = (oldPageNumber?: number, oldPageSize?: number, newPageSize?: number) => {
    if (!oldPageNumber || !oldPageSize || !newPageSize) return 1;

    return Math.floor(((oldPageNumber - 1) * oldPageSize) / newPageSize) + 1;
};
